/**
 * @flow
 * @relayHash 3881ba2bfd476de96aed53b6a01ec2ea
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractorJobsList_contractor$ref = any;
type ContractorJobsList_paymentStatusTypes$ref = any;
type ContractorJobsList_statusTypes$ref = any;
type ContractorJobsTopSection_contractor$ref = any;
export type ContractorJobsTabQueryVariables = {|
  id: string,
  first?: ?number,
  after?: ?string,
  orderBy?: ?string,
  jobDeadlineFrom?: ?any,
  jobDeadlineTo?: ?any,
  jobId?: ?string,
  staffId?: ?string,
  status?: ?string,
  paymentStatus?: ?string,
  releaseId?: ?string,
  productId?: ?string,
  category?: ?string,
  includeInactive?: ?boolean,
  name?: ?string,
|};
export type ContractorJobsTabQueryResponse = {|
  +contractor: ?{|
    +$fragmentRefs: ContractorJobsTopSection_contractor$ref & ContractorJobsList_contractor$ref
  |},
  +jobStatuses: ?{|
    +$fragmentRefs: ContractorJobsList_statusTypes$ref
  |},
  +jobPaymentStatuses: ?{|
    +$fragmentRefs: ContractorJobsList_paymentStatusTypes$ref
  |},
|};
export type ContractorJobsTabQuery = {|
  variables: ContractorJobsTabQueryVariables,
  response: ContractorJobsTabQueryResponse,
|};
*/


/*
query ContractorJobsTabQuery(
  $id: ID!
  $first: Int
  $after: String
  $orderBy: String
  $jobDeadlineFrom: Date
  $jobDeadlineTo: Date
  $jobId: String
  $staffId: String
  $status: String
  $paymentStatus: String
  $releaseId: String
  $productId: String
  $category: ID
  $includeInactive: Boolean
  $name: String
) {
  contractor(id: $id) {
    ...ContractorJobsTopSection_contractor
    ...ContractorJobsList_contractor
    id
  }
  jobStatuses: __type(name: "JobStatus") {
    ...ContractorJobsList_statusTypes
  }
  jobPaymentStatuses: __type(name: "JobPaymentStatus") {
    ...ContractorJobsList_paymentStatusTypes
  }
}

fragment ContractorJobsTopSection_contractor on ContractorNode {
  activeJobsCount
  completedJobsCount
  jobsLifetimeValue
  jobsThisYearValue
}

fragment ContractorJobsList_contractor on ContractorNode {
  assignedJobs(first: $first, after: $after, jobDeadlineFrom: $jobDeadlineFrom, jobDeadlineTo: $jobDeadlineTo, jobId: $jobId, orderBy: $orderBy, staffId: $staffId, status: $status, paymentStatus: $paymentStatus, releaseId: $releaseId, productId: $productId, category: $category, includeInactive: $includeInactive, jobName: $name) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        jobId
        jobDeadline
        name
        status
        created
        releases {
          id
          name
          product {
            id
            title
          }
        }
        isCurrentUserFollowing
        followedDeliverables: deliverables(onlyFollowed: true) {
          edgeCount
        }
        deliverableCategory {
          name
          id
        }
        staffCoordinator {
          representativeImageUrl
          fullName
          id
        }
        totalValue
        currencyCode
        paymentStatus
        hasInvoicesToReview
      }
    }
  }
}

fragment ContractorJobsList_statusTypes on __Type {
  enumValues {
    name
    description
  }
}

fragment ContractorJobsList_paymentStatusTypes on __Type {
  enumValues {
    name
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "jobDeadlineFrom",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "jobDeadlineTo",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "jobId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "staffId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "status",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "paymentStatus",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "releaseId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "productId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "category",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeInactive",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "JobStatus"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "JobPaymentStatus"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "edgeCount",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "enumValues",
    "storageKey": null,
    "args": null,
    "concreteType": "__EnumValue",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ContractorJobsTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contractor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ContractorNode",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContractorJobsTopSection_contractor",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ContractorJobsList_contractor",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobStatuses",
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContractorJobsList_statusTypes",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobPaymentStatuses",
        "name": "__type",
        "storageKey": "__type(name:\"JobPaymentStatus\")",
        "args": (v3/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContractorJobsList_paymentStatusTypes",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ContractorJobsTabQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contractor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ContractorNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "activeJobsCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "completedJobsCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "jobsLifetimeValue",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "jobsThisYearValue",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "assignedJobs",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              {
                "kind": "Variable",
                "name": "category",
                "variableName": "category"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "includeInactive",
                "variableName": "includeInactive"
              },
              {
                "kind": "Variable",
                "name": "jobDeadlineFrom",
                "variableName": "jobDeadlineFrom"
              },
              {
                "kind": "Variable",
                "name": "jobDeadlineTo",
                "variableName": "jobDeadlineTo"
              },
              {
                "kind": "Variable",
                "name": "jobId",
                "variableName": "jobId"
              },
              {
                "kind": "Variable",
                "name": "jobName",
                "variableName": "name"
              },
              {
                "kind": "Variable",
                "name": "orderBy",
                "variableName": "orderBy"
              },
              {
                "kind": "Variable",
                "name": "paymentStatus",
                "variableName": "paymentStatus"
              },
              {
                "kind": "Variable",
                "name": "productId",
                "variableName": "productId"
              },
              {
                "kind": "Variable",
                "name": "releaseId",
                "variableName": "releaseId"
              },
              {
                "kind": "Variable",
                "name": "staffId",
                "variableName": "staffId"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status"
              }
            ],
            "concreteType": "JobNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "JobNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobNode",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "jobId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "jobDeadline",
                        "args": null,
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "created",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "releases",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReleaseNode",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductNode",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "title",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isCurrentUserFollowing",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "followedDeliverables",
                        "name": "deliverables",
                        "storageKey": "deliverables(onlyFollowed:true)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "onlyFollowed",
                            "value": true
                          }
                        ],
                        "concreteType": "DeliverableNodeConnection",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "deliverableCategory",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryNode",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "staffCoordinator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StaffNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "representativeImageUrl",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullName",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalValue",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currencyCode",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "paymentStatus",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasInvoicesToReview",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobStatuses",
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": (v7/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": "jobPaymentStatuses",
        "name": "__type",
        "storageKey": "__type(name:\"JobPaymentStatus\")",
        "args": (v3/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": (v7/*: any*/)
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ContractorJobsTabQuery",
    "id": null,
    "text": "query ContractorJobsTabQuery(\n  $id: ID!\n  $first: Int\n  $after: String\n  $orderBy: String\n  $jobDeadlineFrom: Date\n  $jobDeadlineTo: Date\n  $jobId: String\n  $staffId: String\n  $status: String\n  $paymentStatus: String\n  $releaseId: String\n  $productId: String\n  $category: ID\n  $includeInactive: Boolean\n  $name: String\n) {\n  contractor(id: $id) {\n    ...ContractorJobsTopSection_contractor\n    ...ContractorJobsList_contractor\n    id\n  }\n  jobStatuses: __type(name: \"JobStatus\") {\n    ...ContractorJobsList_statusTypes\n  }\n  jobPaymentStatuses: __type(name: \"JobPaymentStatus\") {\n    ...ContractorJobsList_paymentStatusTypes\n  }\n}\n\nfragment ContractorJobsTopSection_contractor on ContractorNode {\n  activeJobsCount\n  completedJobsCount\n  jobsLifetimeValue\n  jobsThisYearValue\n}\n\nfragment ContractorJobsList_contractor on ContractorNode {\n  assignedJobs(first: $first, after: $after, jobDeadlineFrom: $jobDeadlineFrom, jobDeadlineTo: $jobDeadlineTo, jobId: $jobId, orderBy: $orderBy, staffId: $staffId, status: $status, paymentStatus: $paymentStatus, releaseId: $releaseId, productId: $productId, category: $category, includeInactive: $includeInactive, jobName: $name) {\n    totalCount\n    edgeCount\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        jobId\n        jobDeadline\n        name\n        status\n        created\n        releases {\n          id\n          name\n          product {\n            id\n            title\n          }\n        }\n        isCurrentUserFollowing\n        followedDeliverables: deliverables(onlyFollowed: true) {\n          edgeCount\n        }\n        deliverableCategory {\n          name\n          id\n        }\n        staffCoordinator {\n          representativeImageUrl\n          fullName\n          id\n        }\n        totalValue\n        currencyCode\n        paymentStatus\n        hasInvoicesToReview\n      }\n    }\n  }\n}\n\nfragment ContractorJobsList_statusTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n\nfragment ContractorJobsList_paymentStatusTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b0d201d797118fec17d7db86f906faf4';
module.exports = node;
